export default __webpack_public_path__ + "static/media/logo.6c89ab67.png";